module.exports = __webpack_public_path__ + "media/images/flags/AW-c899f75507d6e5c67b6503b9b138777f.svg";